// Module
var code = "<script>let $ctrl</script> <a class=\"atom-logo-main\" ui-sref=\"dashboard\"> <div class=\"atom-logo-main__wrapper\" id=\"logo-main\"> <img ng-src=\"{{ $ctrl.logoPath }}\" alt=\"logo\"> </div> </a> ";
// Exports
module.exports = code;